import { SimpleBadgeView } from './SimpleBadge.view';
export default SimpleBadgeView;
